module.exports = __webpack_public_path__ + "img/Leap Learning Hotspots user manual 15.01.2020.d5f6dab5.png";